<template>
	<v-dialog
		v-model = "dialog"
		width   = "700"
	>
		<v-card outlined>
			<v-card-title
				class = "body-2 pa-1 success"
			>
				<span 

					class  = "mx-2"
					v-text = "'Activate'"
				></span>

				<v-chip
					label
					x-small
					v-text = "sub_title"
				></v-chip>

				<v-spacer></v-spacer>
				
				<v-btn
					x-small
					class = "error"
					icon
				>					
					<v-icon
						x-small					
						color  = "white"					
						v-text = "'mdi-close'"
						@click = "dialog = false"
					></v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class = "pa-2">
				      <!-- background-color="deep-purple accent-4" -->
				      <!-- center-active -->
				<v-tabs
				      dark
				      fixed-tabs
				      v-model = "tabs"
				    >
				      <v-tab> Hardware Requeriments </v-tab>
				      <!-- <v-tab> Demo </v-tab> -->
				      <v-tab> Register </v-tab>
				      <!-- <v-tab></v-tab> -->
				</v-tabs>

				<v-tabs-items v-model = "tabs">
			      	<v-tab-item
			        	
			        	:key = "1"
			      	>
			        	<v-card
			          		flat
			          		color = ""
			        	>
			          		<v-card-text>
			          			<template v-for = "(item_req, idx_req) of requeriments">
			          				<span 
			          					:key = "idx_req"
			          				>
				          				<v-icon
				          					x-small
				          					v-text = "'mdi-cards-diamond'"
				          				></v-icon>
				          				<span>				          					
			          						{{ item_req }}
				          				</span>
			          				</span>
			          				<br>
			          			</template>
			          		</v-card-text>
			        	</v-card>
			      	</v-tab-item>
			      	<!-- <v-tab-item
			        	:key=""
			        	
			      	>
			        	<v-card
			          		color=""
			          		flat
			        	>
			          		<v-card-text class="pa-1">
			          			<v-row
			          				justify="center"
			          				align="center"
			          			>
			          				<v-col
			          					xl="8" 
			          					lg="8"
			          					md="8"
			          					sm="8"
			          					xs="12"
			          					cols="12"

			          				>
					          			<span>
					          				You can start with Demo version, the period its for 30 days  active
					          			</span>
			          					
			          				</v-col>
			          				
			          				
			          			</v-row>
			          			<br>
			          		</v-card-text>
			          		<v-divider></v-divider>
			          		<v-card-actions>
			          			<v-spacer></v-spacer>
			          			<v-btn
	          						small
	          						color="success"
	          						v-text="'Activate Demo'"
	          						@click="actions('activate_demo')"
	          					></v-btn>
			          			<v-spacer></v-spacer>

			          		</v-card-actions>
			        	</v-card>
			      	</v-tab-item> -->
			      	<v-tab-item
			        	
			        	:key="2"
			      	>
			        	<v-card
			          		flat
			          		color = ""
			        	>
			        	<v-divider></v-divider>
			          		<v-card-text>
			          			<span v-show = "valid_licence">
			          				Please type a license for valid the product and start with service
			          			</span>	 	
		          				<v-row 
		          					no-gutters
		          					justify = "center"
		          					align  	= "center"
		          				>
				          			<template
				          				v-for = "(item_field, idx_field) of info.fields"
				          			>
			          					<v-col
			          						:xl  = " idx_field == 0 ? 12: 6 "
			          						:lg  = " idx_field == 0 ? 12: 6 "
			          						:md  = " idx_field == 0 ? 12: 10 "
			          						sm 	 = "12"
			          						xs   = "12"
			          						cols = "12"
			          						:key = "idx_field"
			          					>	
			          						<v-text-field
			          							dense
			          							outlined
			          							hide-details
			          							:disabled = "!item_field.enable"
			          							v-show 	  = "item_field.active"
			          							:label 	  = "item_field.text"
			          							:suffix   = "item_field.subtext"
			          							:type 	  = "item_field.type"
			          							v-model   = "info.info[item_field.key]"
			          							class 	  = "ma-1"
			          							@input 	  = "item_field.key == 'license' ? check_licence(info.info[item_field.key]) : ''"
			          						>
			          							 <template v-slot:append>
			          							 	<v-tooltip top v-model = "tooltip_try" >
			          							 		<template v-slot:activator ="{ on: tooltip }">
			          							 			
				          							 	<v-icon
				          									v-show = "show_try"
				          							 		color  = "primary"
				          							 		@click = "get_license"
				          							 		v-on   = "{...tooltip}"
				          							 	>
				          							 		mdi-restart
				          							 	</v-icon>
			          							 		</template>
			          							 		<span>
			          							 			Try againg
			          							 		</span>
			          							 	</v-tooltip>
			          							 </template>
			          						</v-text-field>
			          						<v-input
			          							v-if = "item_field.key == 'license'"
			          							:messages = "message"
			          							:success  = "message_color == 'success'"
			          							:error    = "message_color == 'error'"

			          						></v-input>	

			          					</v-col>
			          				</template>

			          				<template
			          					v-for = "(item_client, idx_client) of info_client "
			          				>
			          					<v-col
			          						:xl  = " idx_client == 6 ? 12: 6 "
			          						:lg  = " idx_client == 6 ? 12: 6 "
			          						:md  = " idx_client == 6 ? 12: 10 "
			          						sm 	 = "12"
			          						xs   = "12"
			          						cols = "12"
			          						:key = "idx_client"
			          					>	
				          					<v-card outlined>
				          						<v-card-title>
				          							{{ item_client }}
				          						</v-card-title>
				          					</v-card>
				          				</v-col>
			          				</template>
			          			</v-row>
			          		</v-card-text>
			          		<v-divider></v-divider>
			          		<v-card-actions>
			          			<v-progress-linear
			          				indeterminate
			          				v-show = "loading"
			          				color  = "primary"
			          			></v-progress-linear>
			          			<v-spacer></v-spacer>
			          			<v-btn
	          						small
			          				v-show 	  = "!loading"
	          						color 	  = "success"
	          						v-text 	  = "$ml.get('register')"
	          						@click 	  = "actions('activate')"
	          						:disabled = "valid_licence"
	          					></v-btn>
	          					
	          					<!-- <v-btn
			          				v-show = "!loading"
	          						small
	          						color="primary"
	          						v-text="'test'"
	          						@click="test"
	          						
	          					></v-btn> -->
			          			<v-spacer></v-spacer>
			          		</v-card-actions>
			        	</v-card>
			      	</v-tab-item>
			      </v-tabs-items>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>
	import EventBus from '@/event-bus';
	import axios 	from 'axios';
	export default{
		name: 'activate',
		props: [
			'open_modal',
			'info_to_activate',
			'into_to_license',
			// 'set_info',
		],
		data: () => ({
			dialog 	: false,
			info 	: {
				fields : [
					{
						key 		: 'license',
						text 		: 'license',
						type 		: 'text',	
						placeholder : 'type a license',					
						enable 		: true,
						active 		: true,
					},
					{
						key: 'name',
						text: 'name',
						type : 'text',
						enable : false,
						active : false
						
					},
					{
						key: 	'product',
						text: 'product',
						type : 'text',
						enable : false,
						active : false
					},
					{
						key: 	'version',
						text: 	'version',
						type : 'text',
						enable : false,
						active : false
					},
					
					{
						key: 'description',
						text: 'description',
						type: 'text',	
						active : false,					
					},
					{
						key: 'type',
						text: 'type',
						type: 'text',	
						active : false,					
					},
					{
						key: 'duration',
						text: 'duration',
						subtext: 'days',
						type: 'number',						
						enable: false,
						active: false,
					},
					{
						key: 'start_date',
						text: 'start_date',
						type: 'text',	
						active : false,					
					},
					{
						key: 'end_date',
						text: 'end_date',
						type: 'text',	
						active : false,					
					},
					{
						key: 'status',
						text: 'status',
						type: 'text',						
						active : false,
					},
					{
						key: 'deviceId',
						text: 'deviceId',
						type: 'text',
						active : false,						
					},
					

					/*"name": "Orgil Delta Trade LLC",
					"product":"alice-lpr-mongolia-ubuntu-20"
					"version":"1.0"
					"License": (edited) */
				],
				info: {},
			},			
			info_activate 	: {},
			// info_res 		: {},
			requeriments: [
				'GPU NVIDIA Installed',
				'Intel '
			],			
			action 			: {},
			tabs 			: null,
			sub_title 		: '',
			valid_licence 	: true,
			info_client 	: {},
			message_color 	: '',
			message 		: '',
			loading 		: false,
			show_try 		: true,
			tooltip_try 	: false,
			installing 		: {
				is 					: false,
				error 				: null,
				is_get_container 	: false,
			},
			bus 			: {
				installing_licence : null,
			},
		}), // data

		created(){
		}, // created 

		watch: {
			open_modal: function(val){

				if (val) {
					console.log('open_modal');
					this.render_info();
					this.dialog = true;
				}
			},

			dialog: function(val){
				if (!val) {
					this.close_dialog();
				}
			},

		}, // watch

		methods:{
			actions(act, item){
				if (act == 'activate_demo') {

					this.save();
				}
				if (act == 'activate') {
					if (this.info && this.info.info && this.info.info.license) {
						this.save(this.info.info.license);
					}else if(this.info && this.info.info && this.info.info.type == 'motion'){
						this.save(this.info.info.type);
					}
				}

			}, // actions

			close_dialog(){
				this.$emit('receive_activate', { action: 'close'} );
				
			}, // close dialog

			render_info(){
				let info_up = null;
				let opt_analityc = '';

				if (this.info_to_activate) {
					opt_analityc 		= this.info_to_activate.name;
					this.info_activate 	= this.info_to_activate.info;
					this.sub_title 		= this.$ml.get(opt_analityc).toUpperCase();
				}
				
				if (this.into_to_license) {
					info_up = this.into_to_license;
				}

				info_up.type 		= opt_analityc;

				let days = info_up.duration;
				let date = this.$moment();				

				info_up.start_date	= date;
				info_up.end_date	= this.$moment().add(days, 'days');
				console.log(info_up, 'info activation *********************************+ ');
				this.info.info = info_up;
				if (opt_analityc == "motion") {
					this.info.fields[0].active 	= false;
					this.valid_licence 			= false;
				}else{
					this.info.fields[0].active 	= true;
					this.valid_licence 			= true;
				}
			},

			test(){
				let info_up = {
					createdAt: "2021-07-17T21:51:03.208Z",
					deviceId: "42c26667-04b5-4d38-b2d7-a77ae859afd5",
					id: 77,
					idContainer: ",a0ffcd83ed9a8d86631eabcbf8c18def24eaa9937e2159772ce1312732ee3cea1",
					path_config: "/var/lib/docker/volumes/alice-guardian/_data/config/lpr/devices/7b552b3c-7ac5-46db-98d9-c851e89180ec/config.json",
					status: "running",
					type: "lpr",
					updatedAt: "2021-07-17T21:51:03.208Z",
				}
				this.$emit('receive_activate', { 
						action 	 : 'activate_analytics', 
						activate : info_up.type,
						info  	 : info_up, 
						opt 	 : true,
					});
				
				if (this.info_activate && this.info_activate.container && this.info_activate.container.length >= 0) {
						this.info_activate.container.push(this.info_activate.container[2]);
					}

					this.$Helper.set_local('setting_analytic', {
						analytic : info_up.type,
						info  	 : this.info_activate,

					});
				this.$router.push('setting_analytic');
			},

			save(opt = 'demo'){
				// console.log()
				if (!this.$store.getters["auth/permission"]( this.$route.name || "setting_device", "can_edit", "device")) {
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("setting_device"),
					})
					this.action_to_field.action = '1';
					return false;
				}

				
				let info_up = null;

				if (this.info && this.info.info) {
					info_up = this.info.info;
				}				
				
				info_up.license 	= opt;
				info_up.status 		= true;

				let info_up_1 = { 
					"device_uuid" 	: this.info_activate.deviceId,
					"web_uuid" 		: opt,
					"expire" 		: this.$momentz.now(),
					"type" 			: info_up.type,
					"product_name" 	: info_up.product,
					"version" 		: info_up.version,
					"status" 		: true,
					"image" 		: info_up.image,
					"description" 	: info_up.description ? info_up.description.toLowerCase() : '',
				}
				this.loading = true;				
				
				EventBus.$emit('logs_install_image', true);				
				this.check_download_analytic(info_up);
				const api = this.$URL + '/api/v1/license/register';
				this.$axios.post(api, info_up_1).then( res => {
					this.loading = false;
					console.log(res);
					this.render_activation_license(info_up, res);					
				}).catch( er => {
					console.log('Error', er );
					this.installing.error = er;
					if (!this.installing.is) {
						this.loading = false;
						this.$EventBus.$emit('notifications_modal', {
							type : 'error',
							message : er 

						})
					}
				})
			},

			get_license(license){
				// info_up.status 		= true;
				this.loading = true;
				const api 	 = this.$URL + '/api/v1/license/info';
					console.log("license : ", license)

				this.$axios.post(api, { "license": license }).then( res => {
					console.log(res);
					this.loading = false;

					if (res && res.data) {
						let item = res.data;
						console.log("ITEM VALIDATION : ", item);

						if (item && !item.error &&typeof item !== 'string'){
							let temp = {};
							if (item.device){

								if (item.device.client) {
									this.info.info.name = item.device.client.name;
									this.info.fields[1].active = true;
								}
								if (item.device.version) {
									this.info.info.version = item.device.version.name;
									this.info.fields[3].active = true;	
								}
							}
							if (item.product){
								this.info.info.product 	= item.product.name;
								this.info.info.image 	= item.product.image;
								this.info.info.description = item.product.description ? item.product.description.toUpperCase() : '';
								this.info.fields[2].active = true;
								this.info.fields[4].active = true;

							}			
							if (!item.installation_date) {
								this.message 		= "License Valid for activation";
								this.valid_licence 	= false;
								this.message_color 	= 'success';
							}else{
								this.message 				= "License Not Valid for activation, already was actived";
								this.message_color 		   	= 'error';
								this.valid_licence 			= true;
								this.info.fields[3].active 	= false;
								this.info.fields[2].active 	= false;	
								this.info.fields[1].active 	= false;
							}
							this.show_try  		= false;
						

						} // item
						else{
								
								this.message = item && item.error ? item.error : item;
								this.message_color  = 'error';
								this.valid_licence  = true;	
								this.show_try  		= true;
								this.tooltip_try	= true;								
								this.info.fields[3].active = false;
								this.info.fields[2].active = false;	
								this.info.fields[1].active = false;
										
						} // item
					} // res
					/*this.$EventBus.$emit('notifications_modal', {
						type: 'saved',
					})*/
				}).catch( er => {
					console.log('Error', er );
					this.loading = false;
					
					this.$EventBus.$emit('notifications_modal', {
						type : 'error',
						message : er 

					})
					

				})
			},
			update(){

				const api = this.$URL + '';
				this.$axios.put(api, info_up).then( res => {
					console.log(res);
					this.$EventBus.$emit('notifications_modal', {
						type: 'uptated',
					})
				}).catch( er => {
					console.log('Error', er );
					this.$EventBus.$emit('notifications_modal', {
						type : 'error',
						message : er 

					})
				})
			}, // update

			delete(){
				info_up.status  = true;
				const api 		= this.$URL + '';
				this.$axios.delete(api, info_up).then( res => {
					console.log(res);
					this.$EventBus.$emit('notifications_modal', {
						type: 'deleted',
					})
				}).catch( er => {
					console.log('Error', er );	
				
					this.$EventBus.$emit('notifications_modal', {
						type     : 'error',
						message  : er,  
					})

				})
			}, // delete

			check_licence(license){
				this.valid_licence = true;
				if (license) {
					let temp_license = license.split("-");
					console.log("license : ", license)
					license.trim();
					if (temp_license.length == 5 && license.length == 36 ) {
						this.get_license(license);
						// this.valid_licence = false;

					}else{
						this.message = "Not valid number of characters";
						this.message_color = 'error';
						console.log("Check license : ********************* ", temp_license, license, license.length);
						this.info.fields[1].active = false;
						this.info.fields[2].active = false;
						this.info.fields[3].active = false;	
					}

				}
			}, // check licence

			check_download_analytic(info_up){
				this.installing.is = true;
				if (!this.bus.installing_licence) {					
					this.$EventBus.$on('finish_installation_licence', this.bus.installing_licence =(action)=>{
						
						this.loading 		= false;
						
						console.log("Check license active");				
						/*if(location && location.hostname == `.` || location.hostname == `chromewebdata` || location.localhost == `.`){       				
		       				mainWindow.reload();       			
		       			}else {
		       				location.reload(); 
		       			}*/
		       			axios.defaults.withCredential = false;
		       			if (this.info_activate && this.info_activate.id && !this.installing.is_get_container) {
		       				this.installing.is_get_container = true;
							const api = this.$URL + '/api/v1/device/' + this.info_activate.id;
							axios.get(api).then( res => {
								// this.installing.is 	= false;
								// this.clear_download_analytic();		
								this.installing.is_get_container = false;
								if (res && res.data && res.data.container && res.data.container.length > 0) {
									let info_container =  null;
									info_container = res.data.container.filter(x => {
										if (x && info_up && x.type == info_up.type) {
											return x;		
										}
									});
									if (info_container && info_container.length > 0) {
										this.render_activation_license(info_up, { data : info_container[0] } );
									}else{
										this.installing.is 	= false;
										this.clear_download_analytic();	
									}
									
								}else{
									this.installing.is 	= false;
									this.clear_download_analytic();	
								}
							}).catch(err => {
								this.installing.is 	= false;
								this.installing.is_get_container = false;

								this.clear_download_analytic();	
							})
		       			}else{
		       				this.installing.is 	= false;
							this.clear_download_analytic();	
		       			}
					}); // bus
				}

			}, // check_download_analytic

			clear_download_analytic(){
				this.$Helper.clear_bus(this.$EventBus, this.bus, "activate_licence");
				this.bus.installing_licence = null;
			}, // clear_download_analytic

			render_activation_license(info_up, res){
				EventBus.$emit('render_modules', {
					name		: info_up.type,
					associate 	: info_up
				});

				this.$EventBus.$emit('notifications_modal', {
					type: 'saved',

				})
				this.$emit('receive_activate', { 
					action 	 : 'activate_analytics', 
					activate : info_up.type,
					info  	 : res.data, 
					opt 	 : true,
				});

				if (this.info_activate && this.info_activate.container && this.info_activate.container.length >= 0) {
					this.info_activate.container.push(res.data);
				}

				this.$Helper.set_local('setting_analytic', {
					analytic : info_up.type,
					info 	 : this.info_activate,

				});
				// this.$router.push();
				EventBus.$emit('redirect_view', 'setting_analytic');
				this.dialog 		= false;
				this.clear_download_analytic();
			}, // render activation license

		}, // methods

		mounted(){
			// this.check_download_analytic();

		}, 

		beforeDestroy(){
			this.$Helper.clear_bus(this.$EventBus, this.bus, "activate_licence");
		}, // beforeDestroy

	};
</script>